<template>
  <div class="match-device">
    <div class="main">
      <div class="select">
        <span class="name">赛事类型</span>
        <a-select :default-value="programId" style="width: 120px;margin-left: 10px;" @change="matchSelect" size="large">
          <a-select-option :value="item.id" v-for="(item, index) in allProgramList" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="device">
        <div class="box-list">
          <div class="box-item" v-for="(item, index) in deviceDetailList" :key="index">
            <div class="name">{{ item.name }}</div>
            <div class="d-list">
              <div class="d-item" v-for="(i, j) in item.amountTypes" :key="j">
                <div class="d-name">
                  <div class="d-header">
                    <div class="dot">
                      <a-icon type="check" style="position: absolute;left: 1px;top: 1px;font-weight: bold;" />
                    </div>
                    <span>{{ i.name }}</span>
                  </div>
                  <div class="price">
                    <span style="font-size: 24px;">{{ i.amount }}</span> {{ i.unit }}
                  </div>
                </div>
                <div class="row-item" v-for="(i, j) in item.equipmentDetails">
                  <div class="d-row">
                    <div class="dot">
                      <a-icon type="check" style="position: absolute;left: 1px;top: 1px;font-weight: bold;" />
                    </div>
                    <span>{{ i.name }}</span>
                  </div>
                </div>
                <a-tooltip>
                  <template slot="title">
                    {{ i.remark }}
                  </template>
                  <div class="des">{{ i.remark }}</div>
                </a-tooltip>
              </div>
            </div>
          </div>
        </div>

        <div class="s-list">
          <div
            class="s-item"
            v-for="(item, index) in deviceList"
            :key="index"
            :style="{ marginRight: index % 4 != 3 ? '30px' : '' }"
          >
            <div class="name">{{ item.name }}</div>
            <div class="d-list" v-for="(i, j) in item.amountTypes" :key="j">
              <div class="d-item">
                <div class="header">
                  <div class="dot">
                    <a-icon type="check" style="position: absolute;left: 1px;top: 1px;font-weight: bold;" />
                  </div>
                  <span>{{ i.name }}</span>
                </div>
                <div class="price">
                  <span style="font-size: 24px;">{{ i.amount }}</span> {{ i.unit }}
                </div>
              </div>
              <a-tooltip>
                <template slot="title">
                  {{ i.remark }}
                </template>
                <div class="des">{{ i.remark }}</div>
              </a-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatchCenterDevice',
  props: {},
  components: {},
  data() {
    return {
      deviceList: [],
      deviceDetailList: [],
      allProgramList: [],
      programId: 1,
    }
  },
  mounted() {
    this.getAllProgram()
    this.getMatchEquipmentTypeAmount()
  },
  created() {},
  methods: {
    matchSelect(e) {
      this.programId = e
      this.getMatchEquipmentTypeAmount(0)
    },
    //获取所有项目
    async getAllProgram() {
      try {
        let res = await this.$api.match.getAllProgram()
        console.log(111, res)
        if (res.status == 0) {
          this.allProgramList = res.data
        }
      } catch (error) {}
    },
    //获取所有设备和收费 项目
    async getMatchEquipmentTypeAmount() {
      try {
        let res = await this.$api.match.queryMatchEquipmentTypeAmount(this.programId)
        if (res.status == 0) {
          this.deviceDetailList = []
          this.deviceList = []
          let data = res.data
          const sortTime = (alert1, alert2) => (alert1.amountTypes.length > alert2.amountTypes.length ? -1 : 1)
          let newData = data.sort(sortTime)
          newData.forEach((element) => {
            if (element.equipmentDetails.length > 0) {
              this.deviceDetailList.push(element)
            } else {
              this.deviceList.push(element)
            }
          })
          console.log(111, this.deviceList)
          console.log(222, this.deviceDetailList)
        }
        console.log(111, res)
      } catch (error) {
        console.log(222, error)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.match-device {
  width: 1200px;
  margin: 0 auto;
  .main {
    padding-top: 120px;
    .select {
      width: 100%;
      padding-bottom: 20px;
      border-bottom: 1px solid #c4c4c4;
      margin-bottom: 30px;
      .name {
        font-size: 16px;
        font-weight: bold;
      }
    }
    .device {
      width: 100%;
      border-bottom: 1px solid #c4c4c4;
      margin-bottom: 20px;
      .box-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .box-item {
          width: 585px;
          .name {
            width: 100%;
            height: 60px;
            line-height: 60px;
            font-size: 18px;
            text-align: center;
            background-color: #c4c4c4;
          }
          .d-list {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .d-item {
              width: 292px;
              border: 1px solid #f6f6f6;

              .d-name {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                height: 70px;
                background-color: #f6f6f6;
                margin-bottom: 20px;
                .d-header {
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .dot {
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background-color: #be1e28;
                    color: #ffffff;
                    font-size: 12px;
                    font-weight: bold;
                    position: relative;
                    margin-right: 10px;
                    font-weight: bold;
                  }
                }
                .price {
                  font-size: 14px;
                  font-weight: bold;
                }
              }
              .row-item {
                padding-left: 40px;
                .d-row {
                  display: flex;
                  align-items: center;
                  .dot {
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 2px;
                    background-color: #be1e28;
                    color: #ffffff;
                    font-size: 12px;
                    font-weight: bold;
                    position: relative;
                    margin-right: 10px;
                    font-weight: bold;
                  }
                }
              }
              .des {
                margin-top: 20px;
                background-color: #ffe5cb;
                padding: 10px;
                box-sizing: border-box;
                margin-bottom: 20px;
                min-height: 60px;
                overflow: hidden; //多出的隐藏
                text-overflow: ellipsis; //多出部分用...代替
                display: -webkit-box; //定义为盒子模型显示
                -webkit-line-clamp: 2; //用来限制在一个块元素显示的文本的行数
                -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
              }
            }
          }
        }
      }
      .s-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .s-item {
          width: 277px;
          box-sizing: border-box;
          .name {
            height: 60px;
            line-height: 60px;
            text-align: center;
            font-size: 18px;
            background-color: #c4c4c4;
          }
          .d-list {
            border: 1px solid #f6f6f6;
            padding-top: 5px;
            .d-item {
              color: #333333;
              .header {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: bold;

                .dot {
                  display: inline-block;
                  width: 14px;
                  height: 14px;
                  border-radius: 50%;
                  background-color: #be1e28;
                  color: #ffffff;
                  font-size: 12px;
                  font-weight: bold;
                  position: relative;
                  margin-right: 10px;
                  font-weight: bold;
                }
              }
              .price {
                text-align: center;
                font-weight: bold;
              }
            }

            .des {
              background-color: #ffe5cb;
              padding: 10px;
              box-sizing: border-box;
              margin-bottom: 20px;
              min-height: 60px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/matchcenter/components/MatchCenterDevice.vue